import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import './ContentPage.css';

import { useMtg } from '../../hook/useMtg';
import Layout, { LayoutTemplates } from '../../layouts/layouts';

/**
 * Static content page
 * @component
 */
const ContentPage = ({ title }) => {
	const [content, setContent] = useState('');
	const { getContent } = useMtg();

	useEffect(() => {
		getContent('index', (content) => {
			setContent(content);
		});
	}, [getContent]);

	return (
		<Layout layout={LayoutTemplates.default} title={title}>
			<div className="content-holder">
				<div className="content-wrapper">
					<div
						className="content-page"
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{ __html: content }}
					/>
				</div>
			</div>
		</Layout>
	);
};

ContentPage.propTypes = {
	// Page title for the browser tab
	title: PropTypes.string.isRequired,
};

export default ContentPage;
